import { useQuery } from '@tanstack/react-query';
import { TrendingUp, Users, DollarSign, AlertCircle } from 'lucide-react';
import { Card } from '@/components/ui/Card';
import { apiClient } from '@/services/api';
import { formatCents } from '@/utils/cn';

export function AdminDashboard() {
  const { data: metrics } = useQuery({
    queryKey: ['admin-metrics'],
    queryFn: () => apiClient.admin.getMetrics().then(r => r.data),
  });

  const m = metrics || {};
  return (
    <div className="container-app py-8">
      <div className="rounded-2xl gradient-brand text-white p-6">
        <h1 className="text-2xl font-bold">Painel Master Visual Software</h1>
        <p className="text-white/80 text-sm mt-1">Métricas SaaS em tempo real</p>
      </div>

      <div className="grid gap-4 md:grid-cols-4 mt-8">
        <Stat icon={DollarSign} label="MRR" value={formatCents(m.mrr_cents || 0)} variant="emerald" />
        <Stat icon={TrendingUp} label="ARR" value={formatCents(m.arr_cents || 0)} variant="brand" />
        <Stat icon={Users} label="Tenants ativos" value={m.active_tenants || 0} />
        <Stat icon={AlertCircle} label="Pagamentos atrasados" value={formatCents(m.pending_revenue_cents || 0)} variant="amber" />
      </div>

      <div className="grid gap-4 md:grid-cols-3 mt-6">
        <Card className="p-5">
          <div className="text-xs text-muted-foreground">Tenants</div>
          <div className="mt-2 space-y-1 text-sm">
            <Row label="Trial" value={m.trial_tenants ?? 0} />
            <Row label="Ativos" value={m.active_tenants ?? 0} />
            <Row label="Past Due" value={m.past_due_tenants ?? 0} className="text-amber-600" />
            <Row label="Suspensos" value={m.suspended_tenants ?? 0} className="text-red-600" />
            <Row label="Cancelados" value={m.cancelled_tenants ?? 0} className="text-muted-foreground" />
          </div>
        </Card>
        <Card className="p-5">
          <div className="text-xs text-muted-foreground">TVs</div>
          <div className="mt-2 space-y-1 text-sm">
            <Row label="Total" value={m.total_tvs ?? 0} />
            <Row label="Online" value={m.online_tvs ?? 0} className="text-emerald-600" />
          </div>
        </Card>
        <Card className="p-5">
          <div className="text-xs text-muted-foreground">Últimos 30 dias</div>
          <div className="mt-2 space-y-1 text-sm">
            <Row label="Novos trials" value={m.new_trials_30d ?? 0} />
            <Row label="Conversões" value={m.conversions_30d ?? 0} className="text-emerald-600" />
            <Row label="Churn" value={m.churned_30d ?? 0} className="text-red-600" />
            <Row label="Receita" value={formatCents(m.revenue_30d_cents ?? 0)} className="font-bold" />
          </div>
        </Card>
      </div>
    </div>
  );
}

function Stat({ icon: Icon, label, value, variant = 'default' }: any) {
  const variants: any = { default: 'text-foreground', emerald: 'text-emerald-600', brand: 'text-brand-600', amber: 'text-amber-600' };
  return (
    <Card className="p-5">
      <div className="flex items-center gap-2 text-sm text-muted-foreground"><Icon className="h-4 w-4" />{label}</div>
      <div className={`text-2xl font-bold mt-2 ${variants[variant]}`}>{value}</div>
    </Card>
  );
}

function Row({ label, value, className = '' }: any) {
  return <div className="flex justify-between"><span className="text-muted-foreground">{label}</span><span className={`font-medium ${className}`}>{value}</span></div>;
}
